import { gql } from "@apollo/client";

export const BROADCAST_MESSAGES = gql`
  query BroadcastMessages($eventId: UUID!) {
    broadcastMessages(event_id: $eventId) {
      id
      message
      original_message
      announcement_id
      app_notification_settings {
        title
        audience_kind
        event_part_id
        invitation_ids
      }
      link_type
      channels
      recipient_invitation_ids
      scheduled_at
      status
      total_recipients
      sent_count
      delivered_count
      read_count
      failed_count
      refunded_count
      completed_at
      created_at
      updated_at
    }
  }
`;

export const BROADCAST_MESSAGE_RECIPIENTS = gql`
  query BroadcastMessageRecipients($eventId: UUID!, $broadcastId: UUID!) {
    broadcastMessageRecipients(event_id: $eventId, broadcast_id: $broadcastId) {
      id
      invitation_id
      phone
      channel
      status
      attempts
      inbox_at
      app_eligibility {
        invitation_id
        recipient_user_id
        registered_device_count
        push_device_count
        app_reachability
      }
      sent_at
      delivered_at
      read_at
      failed_at
      failure_reason
      refunded_at
      created_at
      updated_at
      invitation {
        uuid
        first_name
        last_name
        phone
        email
      }
    }
  }
`;

export const GUEST_CATEGORY = gql`
  query guestCategory($eventId: Int!) {
    guestCategory(event_id: $eventId) {
      id
      uuid
      event_id
      name
      created_at
      updated_at
    }
  }
`;

export const NUMBER_OF_GUESTS_BY_CATEGORY = gql`
  query noGuestPerCategory($eventId: Int!) {
    noGuestPerCategory(event_id: $eventId) {
      category_id
      category_name
      message
      num_guest
    }
  }
`;

export const INVITATION_LIST_BY_CATEGORY = gql`
  query invitationListByCategory($eventId: UUID!, $filter: PeopleListFilter!) {
    filterPeople(event_id: $eventId, filter: $filter) {
      total
      meta {
        page
        page_size
        page_count
        record_count
      }
      invitationList {
        id
        event_id
        event_uuid
        uuid
        first_name
        other_name
        last_name
        invitation_mode
        plus_one_request_id
        title
        phone
        email
        sent
        category_id
        category {
          id
          event_id
          name
          message
          created_at
          updated_at
        }
        admits
        rsvp_status
        created_at
        updated_at
        selfie
      }
    }
  }
`;

export const INVITATION_LIST_BY_RSVP = gql`
  query invitationListByRSVP($eventId: UUID!, $filter: PeopleListFilter!) {
    filterPeople(event_id: $eventId, filter: $filter) {
      total
      meta {
        page
        page_size
        page_count
        record_count
      }
      invitationList {
        id
        event_id
        first_name
        last_name
        invitation_mode
        plus_one_request_id
        phone
        sent
        email
        rsvp_status
        category {
          id
          event_id
          name
          created_at
          updated_at
        }
        invitation_status {
          whatsapp {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          sms {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          email {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          direct {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
        }
        admits
        created_at
      }
    }
  }
`;

export const FILTER_INVITATION_LIST = gql`
  query filterInvitationListBy($eventId: UUID!, $filter: PeopleListFilter!) {
    filterPeople(event_id: $eventId, filter: $filter) {
      total
      meta {
        page
        page_size
        page_count
        record_count
      }
      invitationList {
        id
        event_id
        event_uuid
        uuid
        first_name
        other_name
        last_name
        invitation_mode
        plus_one_request_id
        title
        phone
        email
        broadcast {
          broadcast_id
          channel
          link_type
          message
          sent_at
          status
          updated_at
        }
        inawo_pass_image
        inawo_pass_status {
          whatsapp {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          sms {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          email {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          direct {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
        }
        sent
        category_id
        invitation_status {
          whatsapp {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          sms {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          email {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
          direct {
            initiated_at
            sent_at
            delivered_at
            read_at
            failed_at
            failure_reason
          }
        }
        category {
          id
          event_id
          name
          message
          created_at
          updated_at
        }
        rsvp_status
        created_at
        updated_at
        admits
        admits_used
        selfie
      }
    }
  }
`;

export const GET_CHECK_IN_ACTIVITY = gql`
  query FilterInvitationListByCheckIn(
    $eventId: UUID!
    $filter: PeopleListFilter!
  ) {
    filterPeople(event_id: $eventId, filter: $filter) {
      total
      meta {
        page
        page_size
        page_count
        record_count
      }
      invitationList {
        id
        uuid
        event_id
        first_name
        other_name
        last_name
        invitation_mode
        plus_one_request_id
        title
        phone
        email
        activities {
          timestamp
          action
          authorization
          note
        }
        CheckInAt
        sent
        category_id
        category {
          id
          uuid
          event_id
          name
          message
          created_at
          updated_at
        }
        admits
        admits_used
        selfie
        qr_code
        rsvp_status
        created_at
        updated_at
      }
    }
  }
`;

// General Invites Queries
export const GET_GENERAL_INVITE_TOKEN = gql`
  query getGeneralInviteToken($eventId: UUID!) {
    getGeneralInviteToken(event_id: $eventId)
  }
`;

export const GET_GENERAL_INVITES = gql`
  query GetGeneralInvites($eventId: UUID!) {
    getGeneralInvites(event_id: $eventId) {
      id
      event_id
      category_id
      name
      code
      max_uses
      active_used_count
      deleted_used_count
      used_count
      expires_at
      created_at
      remaining_uses
      is_valid
      category {
        id
        uuid
        event_id
        name
        message
        created_at
        updated_at
      }
    }
  }
`;

export const GET_GENERAL_INVITE_GUESTS = gql`
  query GetGeneralInviteGuests($eventId: UUID!) {
    getGeneralInvites(event_id: $eventId) {
      name
      invitations {
        total
        invitationList {
          id
          uuid
          general_invite_id
          first_name
          other_name
          last_name
          invitation_mode
          plus_one_request_id
          title
          phone
          email
          sent
          category_id
          category {
            name
            message
          }
          admits
          admits_used
          selfie
          rsvp_status
          created_at
          updated_at
        }
      }
    }
  }
`;

export const VALIDATE_GENERAL_INVITE_LINK = gql`
  query ValidateGeneralInviteLink($code: String!) {
    validateGeneralInviteLink(code: $code) {
      id
      event_id
      category_id
      name
      code
      max_uses
      active_used_count
      deleted_used_count
      used_count
      expires_at
      created_at
      remaining_uses
      is_valid
      category {
        id
        uuid
        event_id
        name
        message
        created_at
        updated_at
      }
    }
  }
`;

export const GET_CATEGORY_GENERAL_INVITES_BY_ID = gql`
  query CategoryGeneralInvitesById($eventId: Int!, $categoryId: Int!) {
    guestCategoryById(event_id: $eventId, categoryId: $categoryId) {
      general_invites {
        id
        event_id
        category_id
        name
        code
        max_uses
        active_used_count
        deleted_used_count
        used_count
        expires_at
        created_at
        remaining_uses
        is_valid
        category {
          name
        }
      }
    }
  }
`;

// Slots Queries

export const GET_SLOTS = gql`
  query GetSlots($eventId: UUID!) {
    getSlots(event_id: $eventId) {
      id
      event_id
      invitation_id
      code
      max_invites
      invites_used
      allowed_channels
      expires_at
      active
      created_at
      updated_at
    }
  }
`;

export const GET_GUESTS_BY_SLOT_CODE = gql`
  query GetGuestsBySlotCode($eventId: UUID!, $slotCode: String!) {
    getGuestsBySlotCode(event_id: $eventId, slot_code: $slotCode) {
      id
      uuid
      event_id
      event_uuid
      first_name
      other_name
      last_name
      title
      phone
      email
      sent
      category {
        id
        name
      }
      admits
      admits_used
      assigned_slot {
        active
        allowed_channels
        code
        id
        invitation_id
        invites_used
        max_invites
      }
      rsvp_status
    }
  }
`;

export const GET_SLOT_DETAILS = gql`
  query GetSlotDetails($eventId: UUID!, $slotCode: String!) {
    getSlotDetails(event_id: $eventId, slot_code: $slotCode) {
      id
      event_id
      invitation_id
      invitation {
        id
        uuid
        event_id
        event_uuid
        first_name
        other_name
        last_name
        title
        phone
        email
        sent
        category_id
        category {
          id
          name
        }
        admits
        admits_used
        assigned_slot {
          active
          allowed_channels
          code
          id
          invitation_id
          invites_used
          max_invites
        }
        rsvp_status
      }
      category {
        id
        name
      }
      code
      max_invites
      invites_used
      allowed_channels
      expires_at
      active
    }
  }
`;

export const INVITATION_CARD_TEMPLATE = gql`
  query invitationCard($eventId: Int!) {
    invitationCard(event_id: $eventId) {
      id
      uuid
      event_id
      event_uuid
      static_image
      template_id
      template {
        id
        name
        component_url
        thumbnail_url
        schema_fields {
          fields {
            id
            name
            placeholder
            default_value
            required
            style
            position
            regrex
            data_type
            options
          }
        }
        luxe
        created_at
        updated_at
      }
      template_variables {
        id
        name
        value
        style
        position
        data_type
      }
      created_at
      updated_at
    }
  }
`;

export const INVITE_CREDIT_BALANCE = gql`
  query GetInviteCreditBalance($eventId: Int!) {
    event(event_id: $eventId) {
      invite_credit {
        whatsapp
        sms
      }
    }
  }
`;

export const GET_GUEST_UPLOAD = gql`
  query GetGuestUpload($eventId: UUID!) {
    guestUploads(event_id: $eventId) {
      id
      name
      event_id
      event_part_id
      secret
      expires_at
      tags
      description
      created_at
    }
  }
`;

export const PLUS_ONE_REQUESTER_INVITATION = gql`
  query PlusOneRequesterInvitation($plusOneRequestId: UUID!) {
    plusOneRequesterInvitation(plus_one_request_id: $plusOneRequestId) {
      id
      uuid
      title
      first_name
      other_name
      last_name
      phone
      email
      category {
        name
      }
    }
  }
`;

export const PLUS_ONE_REQUESTS = gql`
  query PlusOneRequests($eventId: UUID!) {
    plusOneRequests(event_id: $eventId) {
      id
      invitation {
        id
        uuid
        first_name
        other_name
        last_name
        title
        phone
        email
        category {
          id
          name
        }
        admits
        admits_used
        rsvp_status
      }
      status
      request_type
      guest_email
      guest_first_name
      guest_last_name
      guest_phone
      created_at
    }
  }
`;

export const BROADCAST_ANNOUNCEMENT_STATUS = gql`
  query BroadcastAnnouncementStatus($eventId: UUID!, $broadcastId: UUID!) {
    broadcastAnnouncementStatus(
      event_id: $eventId
      broadcast_id: $broadcastId
    ) {
      id
      event_id
      title
      body
      accepted
      status
      created_at
      invitation_count
      recipient_count
      unreachable_count
      queued_count
      inbox_count
      handed_off_count
      confirmed_delivery_count
      failed_count
      suppressed_count
      read_count
    }
  }
`;
